<div class="dialog-content-wrapper">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Appoint Guardian</span>
      <button (click)="thisDialog.close(false)" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>

  <!-- <div mat-dialog-content style="text-align : center"> -->
  <form class="fullwidth"  [formGroup]="guardianForm" novalidate>
    <div class="formContent">
      <mat-horizontal-stepper #stepper>
        <mat-step label="Bond Amount">
          <mat-form-field style="margin-top: 25px;">
            <input matInput type="number" placeholder="Bond Amount" formControlName="bondAmount" name="bondAmount">
            <!-- <span matPrefix>$&nbsp;</span> -->
            <mat-icon matPrefix>monetization_on</mat-icon>
          </mat-form-field>

          <mat-checkbox aria-label="Bond" formControlName="bond" name="bond">
            Bond has been submitted during hearing
          </mat-checkbox>
          <br>
          <br>
          <div class="stepperControl" style="margin-top: 50px;">
            <button mat-button matStepperNext (click)="loading = false" style="text-transform: uppercase">Next</button>
            
          </div>
        </mat-step>

        <mat-step label="Guardian One">

          <!-- <span>How will the guardian be assigned</span> -->
          <!-- <br />
          <mat-radio-group formControlName="firstGuardianMode" name="firstGuardianMode">
            <mat-radio-button value="TEXT">Enter new user</mat-radio-button>
            <mat-radio-button value="DROP">Pick a user from case</mat-radio-button>
            <mat-radio-button value="LIST">Existing Guardians</mat-radio-button>
          </mat-radio-group>

          <br />
          <br /> -->
          <br *ngIf="guardianForm.controls.guardianBool" />
          <mat-radio-group formControlName="firstGuardianMode" name="firstGuardianMode"  *ngIf="!guardianForm.controls.guardianBool" >
            <mat-radio-button value="TEXT">Enter new user</mat-radio-button>
            <mat-radio-button value="DROP">Pick a user from case</mat-radio-button>
            <mat-radio-button value="LIST">Existing Guardians</mat-radio-button>
          </mat-radio-group>
          <br />

          <mat-form-field *ngIf="guardianForm.controls.firstGuardianMode.value === 'TEXT'">
            <input matInput type="email" placeholder="Guardian email" formControlName="guardianOne" name="guardianOne">
          </mat-form-field>
          
          <mat-form-field *ngIf="guardianForm.controls.firstGuardianMode.value === 'TEXT'">
            <input matInput type="text" placeholder="Guardian firstname" formControlName="guardianOneFirstName"
              name="guardianOneFirstName">
          </mat-form-field>
         

          <mat-form-field *ngIf="guardianForm.controls.firstGuardianMode.value === 'TEXT'">
            <input matInput type="text" placeholder="Guardian lastname" formControlName="guardianOneLastName"
              name="guardianOneLastName">
          </mat-form-field>

          <mat-form-field *ngIf="guardianForm.controls.firstGuardianMode.value === 'TEXT'">
            <input matInput type="text" placeholder="Guardian Address" formControlName="guardianOneAddress"
              name="guardianOneAddress">
          </mat-form-field>

          <mat-form-field *ngIf="guardianForm.controls.firstGuardianMode.value === 'TEXT'">
            <input matInput type="text" placeholder="Guardian Phone No" formControlName="guardianOnePhoneNo"
              name="guardianOnePhoneNo">
          </mat-form-field>

          <mat-form-field *ngIf="guardianForm.controls.firstGuardianMode.value === 'DROP'">
            <mat-select formControlName="guardianOne" name="guardianOne" placeholder="Case contacts">
              <mat-option *ngFor="let contact of caseContacts" [value]="contact.email">{{ contact.name }} - {{
                  contact.email }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="guardianForm.controls.firstGuardianMode.value === 'LIST'">
            <mat-select formControlName="guardianOne" name="guardianOne" placeholder="Guardians">
              <mat-option *ngFor="let guardian of guardianList" [value]="guardian.email">{{ guardian.first_name }} {{ guardian.last_name }}- {{
                  guardian.email }}</mat-option>
            </mat-select>
          </mat-form-field>
          
          <br *ngIf="guardianForm.controls.guardianBool" />
          <a *ngIf="guardianForm.controls.guardianBool" (click)="guardianForm.controls.guardianBool = false">
            - Remove Fiduciary</a>

          <br />
            <div class="stepperControl">
              <button mat-button matStepperPrevious (click)="loading = false"
                style="text-transform: uppercase">Back</button>
              <button mat-button matStepperNext (click)="loading = false" style="text-transform: uppercase">Next</button>
              
            </div>
        </mat-step>
        <mat-step label="Guardian Two">

          <br *ngIf="guardianForm.controls.guardianBool" />

          <!-- <hr *ngIf="!guardianForm.controls.guardianCoBool" /> -->

          <!-- <span *ngIf="!guardianForm.controls.guardianCoBool">How will the co-guardian be assigned</span> -->
          <br *ngIf="!guardianForm.controls.guardianCoBool" />
          <mat-radio-group *ngIf="!guardianForm.controls.guardianCoBool" formControlName="secondGuardianMode"
            name="secondGuardianMode">
            <mat-radio-button value="TEXT">Enter new user</mat-radio-button>
            <mat-radio-button value="DROP">Pick a user from case</mat-radio-button>
            <mat-radio-button value="LIST">Existing Guardians</mat-radio-button>

          </mat-radio-group>

          <br *ngIf="!guardianForm.controls.guardianCoBool" />

          <mat-form-field
            *ngIf="!guardianForm.controls.guardianCoBool && guardianForm.controls.secondGuardianMode.value === 'TEXT'">
            <input matInput type="email" placeholder="Co-Guardian email" formControlName="guardianTwo"
              name="guardianTwo">
          </mat-form-field>

          <mat-form-field
            *ngIf="!guardianForm.controls.guardianCoBool && guardianForm.controls.secondGuardianMode.value === 'TEXT'">
            <input matInput type="text" placeholder="Co-Guardian firstname" formControlName="guardianTwoFirstName"
              name="guardianTwoFirstName">
          </mat-form-field>

          <mat-form-field
            *ngIf="!guardianForm.controls.guardianCoBool && guardianForm.controls.secondGuardianMode.value === 'TEXT'">
            <input matInput type="text" placeholder="Co-Guardian lastname" formControlName="guardianTwoLastName"
              name="guardianTwoLastName">
          </mat-form-field>

          <mat-form-field
            *ngIf="!guardianForm.controls.guardianCoBool && guardianForm.controls.secondGuardianMode.value === 'TEXT'">
            <input matInput type="text" placeholder="Co-Guardian Address" formControlName="guardianTwoAddress"
              name="guardianTwoAddress">
          </mat-form-field>

          <mat-form-field
            *ngIf="!guardianForm.controls.guardianCoBool && guardianForm.controls.secondGuardianMode.value === 'TEXT'">
            <input matInput type="text" placeholder="Co-Guardian Phone No" formControlName="guardianTwoPhoneNo"
              name="guardianTwoPhoneNo">
          </mat-form-field>

          <mat-form-field
            *ngIf="!guardianForm.controls.guardianCoBool && guardianForm.controls.secondGuardianMode.value === 'DROP'">
            <mat-select formControlName="guardianFromCase" name="guardianTwo" placeholder="Case contacts">
              <mat-option *ngFor="let contact of caseContacts" [value]="contact">{{ contact.name }} - {{
                  contact.email }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field
            *ngIf="!guardianForm.controls.guardianCoBool && guardianForm.controls.secondGuardianMode.value === 'LIST'">
            <mat-select formControlName="exsistingGuardian" name="exsistingGuardian" placeholder="Guardians">
              <mat-option *ngFor="let guardian of guardianList" [value]="guardian">{{ guardian.first_name }} {{ guardian.last_name }}- {{
                  guardian.email }}</mat-option>
            </mat-select>
          </mat-form-field>

          <br *ngIf="!guardianForm.controls.guardianCoBool" />

          <a *ngIf="guardianForm.controls.guardianCoBool" (click)="guardianForm.controls.guardianCoBool = false">
            + Add Co Fiduciary</a>
          <a *ngIf="!guardianForm.controls.guardianCoBool" (click)="guardianForm.controls.guardianCoBool = true">
            - Remove Co Fiduciary</a>

          <span class="textColor">{{ guardianFormMessage }}</span>

          <br />

          <!-- <div *ngIf="caseData.acceptance.fiduciary_id !== 'fiduciaryId'">

            <strong>Acceptance Results</strong>

            <div>
              {{ acceptanceData.fiduciaryEmail }} -
              <strong>{{ acceptanceData.fiduciaryResult? 'Accepted': 'Declined' }}</strong>
            </div>

            <br />

            <div *ngIf="acceptanceData.coFiduciaryEmail !== null">
              {{ acceptanceData.coFiduciaryEmail }} -
              <strong>{{ acceptanceData.coFiduciaryResult? 'Accepted': 'Declined' }}</strong>
            </div>

          </div>
          <br> -->
          <br>
          <div class="stepperControl">
            <button mat-button matStepperPrevious (click)="loading = false"
              style="text-transform: uppercase">Back</button>
            <button mat-button matStepperNext (click)="loading = false" style="text-transform: uppercase">Next</button>
            
          </div>

        </mat-step>
        <mat-step label="Check">
          <!-- <span>Which Screening test need to bo done </span>\ -->
          <div class="multiselect">
            <mat-form-field style="margin-top: 60px;">
              <mat-select name="selectPackage" formControlName="selectPackage" placeholder="Select Background Check">
                <mat-option *ngFor="let package of packages" [value]="package.slug">{{package.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <br>

          <div class="stepperControl" style="margin-top: 50px;">
            <button mat-button matStepperPrevious (click)="loading = false"
              style="text-transform: uppercase">Back</button>
            <button [class.loading]="loading" [disabled]="loading" mat-raised-button color="accent" type="submit"
              style="text-transform: uppercase" [style.textAlign]="!loading ? 'center': 'right'"
              (click)="guardianSubmit()">
              <div class="spinner"></div>
              <span class="label">Appoint</span>
            </button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>

      <span class="error" *ngFor="let err of error">{{ err }}
        <br>
      </span>
    </div>

  </form>

  <!-- </div> -->
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/assign-guardian-dialog/assign-guardian-dialog.component.html